"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _PlaybookRecord = _interopRequireDefault(require("playbooks-modal/records/PlaybookRecord"));

var _EngagementTypePropType = _interopRequireDefault(require("playbooks-modal/constants/EngagementTypePropType"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _PlaybookContainer = _interopRequireDefault(require("./PlaybookContainer"));

var _PlaybookBody = _interopRequireDefault(require("./PlaybookBody"));

var _PlaybookFooterButtons = _interopRequireDefault(require("./PlaybookFooterButtons"));

var PlaybookCardBody = function PlaybookCardBody(_ref) {
  var activityType = _ref.activityType,
      activityTypeOptions = _ref.activityTypeOptions,
      callDisposition = _ref.callDisposition,
      callDispositions = _ref.callDispositions,
      configuredPlugins = _ref.configuredPlugins,
      editorState = _ref.editorState,
      engagementType = _ref.engagementType,
      fetchError = _ref.fetchError,
      hasActivityTypes = _ref.hasActivityTypes,
      isPreview = _ref.isPreview,
      isSubmissionSaving = _ref.isSubmissionSaving,
      autoSaveStatus = _ref.autoSaveStatus,
      onActivityTypeChange = _ref.onActivityTypeChange,
      onCallDispositionChange = _ref.onCallDispositionChange,
      onReject = _ref.onReject,
      onEditorStateChange = _ref.onEditorStateChange,
      onEngagementTypeChange = _ref.onEngagementTypeChange,
      onSave = _ref.onSave,
      playbook = _ref.playbook,
      propertiesFetching = _ref.propertiesFetching,
      showSaveButton = _ref.showSaveButton;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UICardSection.default, {
    flush: true,
    className: "playbooks-overlay-body p-y-0 p-x-5"
  }, _react.default.createElement(_PlaybookBody.default, {
    configuredPlugins: configuredPlugins,
    onEditorStateChange: onEditorStateChange,
    isPreview: isPreview,
    playbook: playbook,
    editorState: editorState,
    fetchError: fetchError,
    propertiesFetching: propertiesFetching,
    isSubmissionSaving: isSubmissionSaving
  })), _react.default.createElement(_UICardSection.default, {
    flush: true,
    className: "playbooks-overlay-footer p-x-5 p-y-3"
  }, _react.default.createElement(_PlaybookFooterButtons.default, {
    buttonSize: "small",
    showSaveButton: showSaveButton,
    showCloseButton: false,
    hasActivityTypes: hasActivityTypes,
    engagementType: engagementType,
    activityType: activityType,
    callDisposition: callDisposition,
    callDispositions: callDispositions,
    activityTypeOptions: activityTypeOptions,
    autoSaveStatus: autoSaveStatus,
    onEngagementTypeChange: onEngagementTypeChange,
    onCallDispositionChange: onCallDispositionChange,
    onActivityTypeChange: onActivityTypeChange,
    onSave: onSave,
    onClose: onReject,
    useLogButton: true
  })));
};

PlaybookCardBody.propTypes = {
  activityType: _react.PropTypes.string,
  activityTypeOptions: _react.PropTypes.array,
  callDisposition: _react.PropTypes.string,
  callDispositions: _react.PropTypes.instanceOf(_immutable.OrderedMap).isRequired,
  configuredPlugins: _react.PropTypes.func,
  editorState: _react.PropTypes.object,
  engagementType: _EngagementTypePropType.default,
  fetchError: _react.PropTypes.bool.isRequired,
  hasActivityTypes: _react.PropTypes.bool.isRequired,
  isPreview: _react.PropTypes.bool,
  isSubmissionSaving: _react.PropTypes.bool.isRequired,
  autoSaveStatus: _react.PropTypes.string.isRequired,
  onActivityTypeChange: _react.PropTypes.func.isRequired,
  onCallDispositionChange: _react.PropTypes.func.isRequired,
  onReject: _react.PropTypes.func.isRequired,
  onEditorStateChange: _react.PropTypes.func,
  onEngagementTypeChange: _react.PropTypes.func.isRequired,
  onSave: _react.PropTypes.func.isRequired,
  playbook: _react.PropTypes.instanceOf(_PlaybookRecord.default),
  propertiesFetching: _react.PropTypes.bool.isRequired,
  showSaveButton: _react.PropTypes.bool.isRequired
};
PlaybookCardBody.defaultProps = {
  onEditorStateChange: function onEditorStateChange() {
    return null;
  }
};

var _default = (0, _PlaybookContainer.default)(PlaybookCardBody);

exports.default = _default;
module.exports = exports.default;